import {

    normalizeNumber,

} from "../../../services/numberFormatter.js";

const mapExpenseToForm = (expense) => {

    if (!expense) {

        return null;

    }

    return {

        operateId:

            expense.operateId ?? "0",

        operKindId:

            expense.operKindId ?? "0",

        opTitle:

            expense.opTitle ?? "EM",

        carId:

            expense.car_id ?? "",

        categoryId:

            expense.category_id?.toString() ?? "",

        operDonDate:

            expense.operDonDate ?? "",

        operDonKM: normalizeNumber(

            expense.operDonKM
        
        ),

        cost: normalizeNumber(

            expense.cost
        
        ),

        description:

            expense.description ?? "",

        imageFile:

            null,

        imageUrl:

            expense.imageUrl ?? "",

        fileName:

            expense.fileName ?? "",

        fileSize:

            expense.fileSize ?? null,

    };

};

export default mapExpenseToForm;